module.exports = __webpack_public_path__ + "img/page-404.png?7cde0761943866e187f4c77bd05a78c5";